// extracted by mini-css-extract-plugin
module.exports = {"musicTagSelection":"music-tag-selection-module--music-tag-selection--1TWeK","tag":"music-tag-selection-module--tag--7sFrM","selected":"music-tag-selection-module--selected--1Mf1s"};